module.exports = __webpack_public_path__ + "img/bayer-leverkusen.ba0d0fda.png";